import {Component, Input, OnInit} from '@angular/core';
import {TooltipService} from '../../services/tooltip.service';
import {Tab} from '../../../tabbing/data/tab';

@Component({
  selector: 'app-tooltip-renderer',
  templateUrl: './tooltip-renderer.component.html',
  styleUrls: ['./tooltip-renderer.component.css']
})
export class TooltipRendererComponent implements OnInit {

  @Input() tab: Tab;

  constructor(public tooltipService: TooltipService) {
    this.tooltipService = tooltipService;
  }

  ngOnInit() {
  }

}
